<h2 *ngIf="context.type !== 'ring-gauge' && context.showTitle !== false" class="chart-title">
  {{ context.title }}
</h2>
<div
  class="chart-state"
  [class.chart--heatmap]="context.type === 'heatmap'"
    [class.chart--tree]="context.type === 'tree'"
  [class.chart--gauge]="context.type === 'gauge'"
  [class.chart--ring-gauge]="context.type === 'ring-gauge'"
  role="status"
  aria-label="در حال بارگذاری"
  *ngIf="context.loading"
>
  <span class="spinner-border" aria-hidden="true"></span>
</div>
<div
  class="chart-state"
  [class.chart--heatmap]="context.type === 'heatmap'"
    [class.chart--tree]="context.type === 'tree'"
  [class.chart--gauge]="context.type === 'gauge'"
  [class.chart--ring-gauge]="context.type === 'ring-gauge'"
  role="alert"
  *ngIf="!context.loading && context.error"
>
  {{ context.error }}
</div>
<ng-container *ngIf="!context.loading && !context.error">
  <div
    class="chart-state"
    [class.chart--heatmap]="context.type === 'heatmap'"
    [class.chart--tree]="context.type === 'tree'"
    [class.chart--gauge]="context.type === 'gauge'"
    [class.chart--ring-gauge]="context.type === 'ring-gauge'"
    role="status"
    *ngIf="!hasData"
  >
    داده‌ای برای نمایش وجود ندارد.
  </div>
  <div
    *ngIf="hasData"
    echarts
    class="chart"
    [style.height.px]="context.type === 'heatmap' ? heatmapHeight : null"
    [class.chart--heatmap]="context.type === 'heatmap'"
    [class.chart--tree]="context.type === 'tree'"
    [class.chart--gauge]="context.type === 'gauge'"
    [class.chart--ring-gauge]="context.type === 'ring-gauge'"
    [options]="options"
    [autoResize]="false"
    (chartInit)="onChartInit($event)"
    (chartClick)="onChartClick($event)"
    role="img"
    [attr.aria-label]="context.title"
  ></div>
</ng-container>
